// extracted by mini-css-extract-plugin
export default {"container":"NE-z","modal":"OE-z","dimensions":"PE-z","brandName":"QE-z","productName":"RE-z","labelValue":"SE-z","recipientEmail":"TE-z","recommendedFit":"UE-z","hiddenField":"VE-z"};